import {create} from 'zustand'

export type PatientEditingFieldsGroup = 'personal-data' | 'contacts' | 'medical-info' | 'privacy' | 'note' | 'vademecum'

type PatientDetailsStore = {
    isErrorBannerVisible: boolean
    editingFieldsGroup: PatientEditingFieldsGroup | null
    setEditingFieldsGroup: (value: PatientEditingFieldsGroup | null) => void
    setIsErrorBannerVisible: (value: boolean) => void
}

export const usePatientDetailsStore = create<PatientDetailsStore>()(set => ({
    isErrorBannerVisible: false,
    editingFieldsGroup: null,
    setEditingFieldsGroup: value => set({editingFieldsGroup: value}),
    setIsErrorBannerVisible: value => set({isErrorBannerVisible: value})
}))
